import { bootAlpinePage } from '../shared/alpineBoot.js';
import { bootI18n } from '../shared/i18nBoot.js';
import { redirectIfAuthenticated } from '../shared/auth.js';
import { registerPwa } from '../shared/pwaRegister.js';
import { loginPage } from './loginPage.js';

registerPwa();

await bootI18n();
bootAlpinePage( { globalName: 'loginPage', factory: loginPage } );
redirectIfAuthenticated();
